const firebaseConfig = {
  apiKey: "AIzaSyBgHRLmBOSHKVqUgq6MqydGzwbtMXrfoQk",
  authDomain: "need-b4ba6.firebaseapp.com",
  projectId: "need-b4ba6",
  storageBucket: "need-b4ba6.appspot.com",
  messagingSenderId: "281281540286",
  appId: "1:281281540286:web:8fca413b6cb703f73eeeef",
  measurementId: "G-8BEQC0F1MR"
};

export default firebaseConfig;
